












import Vue from 'vue'

export default Vue.extend({
  name: 'NotLogged',
  computed: {
    currentLocation (): string {
      const rawString = window.location.href.replace(this.$route.path, '')
      return rawString + '/login-response'
    },
    href (): string {
      return process.env.VUE_APP_SEDE_URL + this.currentLocation
    }
  },
  methods: {
    onButtonClicked (): void {
      window.open(this.href, '_self')
    }
  }
})
